import { SET_FILTERED_RESULTS_COUNT } from './constants';

export const initialState = {};

function reducer(state = initialState, action) {
  let nextState = state;
  switch (action.type) {
    case SET_FILTERED_RESULTS_COUNT:
      nextState = { ...state, filteredResultsCount: action.filteredResultsCount };
      break;
    default:
      nextState = state;
  }
  return nextState;
}

export default reducer;



// WEBPACK FOOTER //
// ./src/containers/Search/reducer.js